import React from 'react'
import numeral from 'numeral'
import { Link } from 'react-router-dom'
import { Avatar, ExpertProfileHighlightIcon } from '@deal/components'
import { ConversationExpertFragment } from '#src/generated/graphql'
import styles from './styles.css'

interface ConversationStarterProps {
  expert: ConversationExpertFragment
}

const ConversationStarter: React.SFC<ConversationStarterProps> = ({ expert }) => {
  const expertName = [expert.firstName, expert.lastName].filter(Boolean).join(' ')
  const profile = expert.expertProfile
  const highlights =
    profile && profile.highlights && profile.highlights.length > 0 ? profile.highlights : undefined
  const expertStats = expert.expertStats ? expert.expertStats : null
  const isPlaceholderExpert = expert.expertAttributes && expert.expertAttributes.placeholderExpert

  return (
    <div className={styles.profile}>
      <div className={styles.identity}>
        <div className={styles.avatar}>
          {isPlaceholderExpert ? (
            <Avatar
              name={expertName}
              src={
                expert.expertProfile && expert.expertProfile.profilePhoto
                  ? expert.expertProfile.profilePhoto.url
                  : undefined
              }
              size={64}
            />
          ) : (
            <Link to={`/experts/${expert.vanityId}`}>
              <Avatar
                name={expertName}
                src={
                  expert.expertProfile && expert.expertProfile.profilePhoto
                    ? expert.expertProfile.profilePhoto.url
                    : undefined
                }
                size={64}
              />
            </Link>
          )}
        </div>
        <div className={styles.intro}>
          {isPlaceholderExpert ? (
            <span className={styles.name}>{expertName}</span>
          ) : (
            <Link to={`/experts/${expert.vanityId}`} className={styles.name}>
              {expertName}
            </Link>
          )}
          {profile && profile.headline && <div className={styles.headline}>{profile.headline}</div>}
        </div>
      </div>

      <div className={styles.sections}>
        {highlights && (
          <ul className={styles.highlights}>
            {expertStats && (
              <>
                {expertStats.totalMessages > 0 && (
                  <li className={styles.highlight}>
                    <ExpertProfileHighlightIcon glyph="CHAT" className={styles.highlightIcon} />
                    <span className={styles.highlightValue}>Total messages</span>
                    <span className={styles.highlightSecondaryValue}>
                      {numeral(expertStats.totalMessages).format('0,0')}
                    </span>
                  </li>
                )}
                {expertStats.totalReviews > 0 && (
                  <li className={styles.highlight}>
                    <ExpertProfileHighlightIcon glyph="STAR" className={styles.highlightIcon} />
                    <span className={styles.highlightValue}>Total reviews</span>
                    <span className={styles.highlightSecondaryValue}>
                      {numeral(expertStats.totalReviews).format('0,0')}
                    </span>
                  </li>
                )}
              </>
            )}

            {highlights.map(highlight => (
              <li
                className={styles.highlight}
                key={`${highlight.type.id}:${highlight.value}:${highlight.secondaryValue}`}
              >
                <ExpertProfileHighlightIcon
                  glyph={highlight.type.icon}
                  className={styles.highlightIcon}
                />
                <span className={styles.highlightValue}>{highlight.secondaryValue}</span>
                <span className={styles.highlightSecondaryValue}>{highlight.value}</span>
              </li>
            ))}
          </ul>
        )}

        {!isPlaceholderExpert && (
          <div className={styles.viewLink}>
            <Link to={`/experts/${expert.id}`} className={styles.expertProfileLink}>
              View full profile
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default ConversationStarter
